/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

// eslint-disable-next-line react/prop-types
export const ImageSVG = ({ selected }) => (
  selected ? (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6927_110471)">
        <path d="M2.3998 15.2C1.9598 15.2 1.58327 15.0435 1.2702 14.7304C0.957138 14.4174 0.800338 14.0406 0.799805 13.6V2.40005C0.799805 1.96005 0.956605 1.58352 1.2702 1.27045C1.5838 0.957382 1.96034 0.800582 2.3998 0.800049H13.5998C14.0398 0.800049 14.4166 0.956849 14.7302 1.27045C15.0438 1.58405 15.2003 1.96058 15.1998 2.40005V13.6C15.1998 14.04 15.0433 14.4168 14.7302 14.7304C14.4171 15.044 14.0403 15.2006 13.5998 15.2H2.3998ZM2.3998 13.6H13.5998V2.40005H2.3998V13.6ZM3.1998 12H12.7998L9.7998 8.00005L7.3998 11.2L5.5998 8.80005L3.1998 12Z" fill="#3800EE" />
      </g>
      <defs>
        <clipPath id="clip0_6927_110471">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.3998 15.2C1.9598 15.2 1.58327 15.0435 1.2702 14.7304C0.957138 14.4174 0.800338 14.0406 0.799805 13.6V2.40005C0.799805 1.96005 0.956605 1.58352 1.2702 1.27045C1.5838 0.957382 1.96034 0.800582 2.3998 0.800049H13.5998C14.0398 0.800049 14.4166 0.956849 14.7302 1.27045C15.0438 1.58405 15.2003 1.96058 15.1998 2.40005V13.6C15.1998 14.04 15.0433 14.4168 14.7302 14.7304C14.4171 15.044 14.0403 15.2006 13.5998 15.2H2.3998ZM2.3998 13.6H13.5998V2.40005H2.3998V13.6ZM3.1998 12H12.7998L9.7998 8.00005L7.3998 11.2L5.5998 8.80005L3.1998 12Z" fill="black" />
    </svg>
  )
);
